var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.097,467.835c-22.439,0-44.117,0-68.738,0c16.865-17.54,32.082-33.356,47.288-49.183 c34.586-36.001,68.699-72.47,103.861-107.9c49.929-50.308,128.623-52.611,182.48-6.167c4.441,3.829,8.639,7.969,12.7,12.205 c47.589,49.627,95.13,99.3,144.146,150.488c-23.779,0-45.68,0-61.576,0c-27.088-24.997-51.791-47.076-75.637-70.045 c-16.603-15.993-31.52-33.734-48.086-49.77c-34.964-33.845-88.881-32.24-123.142,3.208c-35.277,36.499-70.371,73.176-105.571,109.75 C79.228,463.118,76.423,465.612,74.097,467.835z M15.349,48.456c45.525,47.595,91.071,95.17,136.609,142.752 c55.569,58.063,143.449,57.24,199.318-1.535c42.191-44.385,84.798-88.375,127.175-132.583c4.713-4.917,9.135-10.113,15.229-16.889 c-25.423,0-47.933,0-62.08,0c-23.943,21.71-43.734,38.679-62.372,56.832c-18.618,18.133-35.908,37.62-54.086,56.215 c-38.497,39.38-92.515,38.521-130.21-1.285c-35.462-37.447-71.449-74.396-107.341-111.705c-22.311,0-44.511,0-69.407,0 C11.651,44.238,13.412,46.431,15.349,48.456z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.c7666bd6ef76680c763952acd0d09a31.svg";
export { ForwardRef as ReactComponent };